import React from "react";
import Portfolio from "Pages/Portfolio";


const Hisotrytheme = () => {
  return (
    <React.Fragment>
        <Portfolio/>
    </React.Fragment>
  );
};

export default Hisotrytheme;
